import {useParams} from "react-router";

import Footer from "../components/Footer/Footer";
import styles from "../styles/Project.module.scss";
import projects from "../data/Projects";

const Project = () => {
  const {projectname} = useParams();
  const project = projects.filter((ele) => ele.title === projectname)[0];

  return (
    <>
      <div className={styles.project}>
        <h1>{project?.title}</h1>
        <div>
          <div className={styles.picture}>
            <div
              style={{
                backgroundImage: `url(${project.image})`,
              }}
            />
            <img src={project.image} alt="project pic" />
          </div>
          <div>
            <h6>Introduction</h6>
            <p>{project?.para1}</p>
            <p>{project?.para2} </p>
            <p>
              Github link:
              <a href={project.githublink}>{project?.githublink}</a>
            </p>
            {project?.websitelink && (
              <p>
                Project link:
                <a href={project.websitelink}>{project?.websitelink}</a>
              </p>
            )}
          </div>
        </div>
        <p>{project?.para3}</p>
        <p>{project?.para4}</p>
        <p>Technologies used: {project?.techStack}.</p>
      </div>
      <Footer title="Project" />
    </>
  );
};

export default Project;
